const colorOrder = ['red', 'green', 'yellow', 'blue', 'wild', 'rainbow'];
const contentOrder = {
    'plusTwo': 10,
    'reverse': 11,
    'skip': 12,
    'colorChange': 13,
    'plusFour': 14,
    'rainbow': 15,
};

const getContentOrder = (content) => {
    const num = parseInt(content);
    if (!isNaN(num)) {
        return num; // numbers are sorted as they are
    }
    // if not a number, sort back based on their contentOrder
    return contentOrder[content] || 100; // unknown actions at the end
};

export const sortCards = (cards) => {
    return cards
        ? [...cards].sort((a, b) => {
            const colorComparison = colorOrder.indexOf(a.color) - colorOrder.indexOf(b.color);
            if (colorComparison === 0) {
                return getContentOrder(a.content) - getContentOrder(b.content);
            }
            return colorComparison;
        })
        : [];
};
